/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GoalRequestDto } from './goalRequestDto';


export interface CreateCarePlanRequestDto { 
    /**
     * Patient identifier
     */
    patientId: string;
    /**
     * Problem identifier
     */
    problemId: string;
    /**
     * Plan type element ID from Reference Data Service. References a specific care plan type in the care-plan-types collection.
     */
    elementId: string;
    /**
     * Collection ID (care-plan-types). Auto-populated by the service.
     */
    collectionId: string;
    /**
     * Care plan title
     */
    title: string;
    /**
     * Care plan description
     */
    description?: string;
    /**
     * Reason for the current status
     */
    statusReason?: string;
    /**
     * Care plan start date
     */
    startDate: string;
    /**
     * Care plan end date
     */
    endDate?: string;
    /**
     * Initial goals for the care plan
     */
    goals?: Array<GoalRequestDto>;
    /**
     * Initial observation IDs to link to the care plan. Each observation ID will be validated against the observation types collection.
     */
    observationIds?: Array<string>;
    /**
     * The healthcare provider or clinician who is managing the care plan
     */
    managingProvider: string;
    /**
     * Additional structured metadata that will be validated against the recordSchema defined in the care plan type
     */
    metadata?: any;
    /**
     * Optional encounter identifier to link this care plan to an encounter at creation time
     */
    encounterId?: string;
    /**
     * Fields to expand in the response
     */
    expand?: Array<CreateCarePlanRequestDto.ExpandEnum>;
}
export namespace CreateCarePlanRequestDto {
    export type ExpandEnum = 'care-plan-type' | 'work-items' | 'encounters' | 'observation-types';
    export const ExpandEnum = {
        CarePlanType: 'care-plan-type' as ExpandEnum,
        WorkItems: 'work-items' as ExpandEnum,
        Encounters: 'encounters' as ExpandEnum,
        ObservationTypes: 'observation-types' as ExpandEnum
    };
}


